const ActorTypeEnum = {
  CANDIDATE: 'candidate',
  STUDENT: 'student',
};

export default ActorTypeEnum;
